import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import SublocationKeys from 'src/constants/locale/key/Sublocation'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let regexAlphaNumeric = "^[a-zA-Z0-9 .,_()-]*$"
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  let maxLength10 = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.Validations.MAX_LENGTH_10
  )

  let maxLength150 = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.Validations.MAX_LENGTH_150
  )

  let maxLength250 = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.Validations.MAX_LENGTH_250
  )

  let alphaNumericErrorMessage = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.Validations.ALPHA_NUMERIC_SPACE_REGX
  )

  return Yup.object({
    intlcode: Yup.string().matches(regexAlphaNumeric,alphaNumericErrorMessage).required(requiredMessage).max(10,maxLength10),
    language: Yup.string().matches(regexAlphaNumeric,alphaNumericErrorMessage).required(requiredMessage).max(10,maxLength10),
    indicator: Yup.string().required(requiredMessage),
    address: Yup.string().matches(regexAlphaNumeric,alphaNumericErrorMessage).max(150,maxLength150),
    descriptionEn: Yup.string().matches(regexAlphaNumeric,alphaNumericErrorMessage).required(requiredMessage).max(250,maxLength250),
    code: Yup.string().matches(regexAlphaNumeric,alphaNumericErrorMessage).required(requiredMessage).max(10,maxLength10)
      .transform((value, originalValue) => {
        return originalValue === null || originalValue === 'null' || originalValue === undefined
          ? ''
          : originalValue;
      })
  })
}

export default makeValidationSchema
